<template>
  <auth-shell>
    <p class="auth-form__eyebrow">
      Tu cuenta
    </p>
    <h1 class="auth-form__title auth-form__title--with-lead">
      Confirmar tu correo
    </h1>
    <p class="auth-form__lead">
      Así nos aseguramos de que tus cotizaciones y facturas te lleguen sin problema.
    </p>

    <div
      v-if="loading"
      class="auth-status auth-status--loading"
    >
      <b-spinner small />
      <span>Estamos validando tu liga...</span>
    </div>

    <div
      v-else
      :class="['auth-status', success ? 'auth-status--success' : 'auth-status--error']"
      role="status"
    >
      <feather-icon
        :icon="success ? 'CheckCircleIcon' : 'AlertTriangleIcon'"
        size="18"
      />
      <span>{{ message }}</span>
    </div>

    <b-button
      v-if="!loading"
      class="auth-submit"
      block
      @click="goNext"
    >
      <span>{{ isLoggedIn ? 'Ir a YoConstruyo' : 'Iniciar sesión' }}</span>
      <feather-icon
        icon="ArrowRightIcon"
        size="18"
      />
    </b-button>
  </auth-shell>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import { getHomeRouteForLoggedInUser, isUserLoggedIn, getUserData } from '@/auth/utils'
import AuthShell from '@/components/auth/AuthShell.vue'

export default {
  components: {
    AuthShell,
    BButton,
    BSpinner,
  },

  data() {
    return {
      loading: true,
      success: false,
      message: '',
      isLoggedIn: isUserLoggedIn(),
    }
  },

  created() {
    this.$store.dispatch('auth/confirmEmail', this.$route.params.token)
      .then(() => {
        this.success = true
        this.message = 'Tu correo quedó confirmado. Gracias.'
      })
      .catch(error => {
        const messages = error?.response?.data?.messages
        this.success = false
        this.message = Array.isArray(messages) && messages.length ? messages.join(' ') : 'La liga no es válida o ya se usó.'
      })
      .finally(() => {
        this.loading = false
      })
  },

  methods: {
    goNext() {
      if (this.isLoggedIn) {
        this.$router.replace(getHomeRouteForLoggedInUser(getUserData()))
        return
      }
      this.$router.replace({ name: 'auth-login' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../components/auth/auth-page.scss';
</style>
